<template>
  <div>
   <b-modal size="lg" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalcategory" @close="this.emitEventCancel" @ok="this.emitEventOK" @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 

    <b-row>
      <div class="col-sm-12 col-md-12">
          <div class="textlabel" :data-label="this.$t('Shared.SearchElements')" style="padding: 0em 0!important;">
              <div class="input-group" dir="ltr">
                  <input 
                    type="text" 
                    class="form-control"
                    :dir="dirInput"
                    v-model="SearchCriteria"
                    @keyup.enter="Search()"
                  >
                  <div class="input-group-append">
                      <MdButton 
                        v-bind:Name="'btnsearchinput'"
                        v-bind:VariantProp="'btn btn-sm search-attached'"
                        v-bind:IconClass="'mdi mdi-magnify'"
                        v-on:click="Search()">
                      </MdButton>
                  </div>
              </div>
          </div>
      </div> 
  </b-row> 
  <MdTitle v-bind:Text="$t('dcsList.ContentCSV')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" style="width: 100%;"/> 

  
                    <MdTablePaginationClient
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="'modalViewtabledcs'"                                       
                    :onRowSelected="onRowSelected"
                     :RowClick="RowClick"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction">
                  </MdTablePaginationClient>  
           

  <MdPasswordDlg v-if="showSignPassword" 
  v-bind:Type="TypePassWord"
  v-bind:VerificationType="'SupervisorPassword'"
  @getModalPassword="onModalPasswordResultModal($event)"
/>

          
     
   </b-modal>   
  </div>
</template>

<script>
//import Utils from '@/common/utils'
import ShowMessage from '@/components/messages/ShowMessage.js'
//import IncidentReportInterventionsSetups from '@/services/incidentreportinterventionssetups.service'
//import IncidentReportSeveritySetup from '@/services/incidentreportseveritysetup.service'
//import IncidentSetup from '@/services/incidentsetup.service'

export default {
 name: 'ModalViewDCS',
 mixins: [ShowMessage],  
 props: {
     ModalId: String,
     TitleWindow: String,
     ReadOnly:Boolean,
     GroupCreationId:String,
     Year:String,
     Month:String,
     Version:String,
 },
 
 data(){
   return {
        SearchCriteria:"",    
        labelremove:"Remove",
        labelDownload:"Download",
        TypePassWord:"Sign",
        showSignPassword:false,
        fields:[
          { key: 'email_Address', sortable: true, label: 'email_Address', class: 'text-rigth' },  
          { key: 'phone_Number', sortable: true, label: 'phone_Number', class: 'text-rigth' },
          { key: 'vendor_ID', sortable: true, label: 'vendor_ID', class: 'text-rigth' },
          { key: 'vendor_Location', sortable: true, label: 'vendor_Location', class: 'text-rigth'},  
          { key: 'vendor_Address_Seq', sortable: true, label: 'vendor_Address_Seq', class: 'text-rigth' },
          { key: 'invoice_Type', sortable: true, label: 'invoice_Type', class: 'text-rigth' },
          { key: 'bill_Type', sortable: true, label: 'bill_Type', class: 'text-rigth' }, 
          { key: 'invoice_Number', sortable: true, label: 'invoice_Number', class: 'text-rigth' }, 
          { key: 'invoice_Date', sortable: true, label: 'invoice_Date', class: 'text-rigth' }, 
          { key: 'service_Type', sortable: true, label: 'service_Type', class: 'text-rigth' }, 
          { key: 'billable_Unit_ID', sortable: true, label: 'billable_Unit_ID', class: 'text-rigth' }, 
          { key: 'person_ID', sortable: true, label: 'person_ID', class: 'text-rigth' }, 
          { key: 'case_ID', sortable: true, label: 'case_ID', class: 'text-rigth' }, 
          { key: 'billing_Code', sortable: true, label: 'billing_Code', class: 'text-rigth' }, 
          { key: 'service_Code', sortable: true, label: 'service_Code', class: 'text-rigth' }, 
          { key: 'component_Code', sortable: true, label: 'component_Code', class: 'text-rigth' }, 
          { key: 'start_Date', sortable: true, label: 'start_Date', class: 'text-rigth' }, 
          { key: 'end_Date', sortable: true, label: 'end_Date', class: 'text-rigth' }, 
          { key: 'units', sortable: true, label: 'units', class: 'text-rigth' }, 
          { key: 'uom', sortable: true, label: 'uom', class: 'text-rigth' }, 
          { key: 'rate', sortable: true, label: 'rate', class: 'text-rigth' }, 
          { key: 'amount', sortable: true, label: 'amount', class: 'text-rigth' }, 
          { key: 'country_Code', sortable: true, label: 'country_Code', class: 'text-rigth' }, 
          { key: 'comments', sortable: true, label: 'comments', class: 'text-rigth' }, 
          { key: 'place_of_Service', sortable: true, label: 'place_of_Service', class: 'text-rigth' }, 
          { key: 'mdrC_1', sortable: true, label: 'mdrC_1', class: 'text-rigth' }, 
          { key: 'mdrC_2', sortable: true, label: 'mdrC_2', class: 'text-rigth' }, 
          { key: 'mdrC_3', sortable: true, label: 'mdrC_3', class: 'text-rigth' }, 
          { key: 'mdrC_4', sortable: true, label: 'mdrC_4', class: 'text-rigth' }, 
          { key: 'mdrC_5', sortable: true, label: 'mdrC_5', class: 'text-rigth' }, 
          { key: 'title', sortable: true, label: 'title', class: 'text-rigth' }, 
          { key: 'type', sortable: true, label: 'type', class: 'text-rigth' },
          { key: 'content', sortable: true, label: 'content', class: 'text-rigth' },         
        ],
        items:[],
        pageOptions: [5, 10, 15 ],
        totalRows: 4,
        currentPage: 1,
        perPage: 10,
        ShowMessageIsEmpty:false,
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',

   }
 },

 methods:{
  Search(){

  }
 },

  mounted(){
  
 },
};
</script>